import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import * as serviceWorker from './serviceWorker';
import store from "./data/store"
import RouterSwitchComponent from "./presentation/views/components/RouterSwitchComponent";
import Analytics from  "./presentation/analytics/Analytics";
import Intercom from 'react-intercom';
import {getIntercomUser} from './presentation/shared/getUserIntercom/GetUserIntercom';
import i18n from "./i18n";

if (process.env.REACT_APP_LANGUAGE) {
    i18n.changeLanguage(process.env.REACT_APP_LANGUAGE);
}

const INTERCOM_APPID = `${ process.env.REACT_APP_INTERCOM_APPID}`
const USER_DATA = getIntercomUser()

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <Analytics />
             <Intercom appID={INTERCOM_APPID} { ...USER_DATA } />
            <Route component={RouterSwitchComponent} />
        </BrowserRouter>
    </Provider>, document.getElementById('root'));

serviceWorker.unregister();
